<template>
  <svg fill="none" height="16" viewBox="0 0 14 16" width="14" xmlns="http://www.w3.org/2000/svg">
    <circle cx="6.89563" cy="8.06531" fill="white" r="6.70203"/>
    <path
        d="M6.90403 5.36543C6.65736 5.36543 6.4507 5.28876 6.28403 5.13543C6.12403 4.97543 6.04403 4.77876 6.04403 4.54543C6.04403 4.3121 6.12403 4.11876 6.28403 3.96543C6.4507 3.80543 6.65736 3.72543 6.90403 3.72543C7.15069 3.72543 7.35403 3.80543 7.51403 3.96543C7.6807 4.11876 7.76403 4.3121 7.76403 4.54543C7.76403 4.77876 7.6807 4.97543 7.51403 5.13543C7.35403 5.28876 7.15069 5.36543 6.90403 5.36543ZM7.59403 6.02543V11.5654H6.19403V6.02543H7.59403Z"
        fill="#1EBCD5"/>
  </svg>
</template>
